import { taasInfoReducer } from '@ps20-frontend/preis-lib';
import { AnyAction } from 'redux';
import { App, TaasInfo } from '@ps20-frontend/frontend-models';

export const thhPferdTaasInfoReducer = function (
  sectionState: TaasInfo = null,
  action: AnyAction,
): TaasInfo {
  return taasInfoReducer(sectionState, action, App.THH_PFERD);
};
